import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowExpenseShort = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 8,
	viewBox: "0 0 9 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.85355 4.1514C9.04882 3.95614 9.04882 3.63956 8.85355 3.4443L5.67157 0.262318C5.47631 0.0670555 5.15973 0.0670555 4.96447 0.262318C4.7692 0.45758 4.7692 0.774162 4.96447 0.969424L7.79289 3.79785L4.96447 6.62628C4.7692 6.82154 4.7692 7.13812 4.96447 7.33339C5.15973 7.52865 5.47631 7.52865 5.67157 7.33339L8.85355 4.1514ZM0.5 4.29785H8.5V3.29785H0.5V4.29785Z",
		fill: "#D8D9DC"
	})
});
export default SvgArrowExpenseShort;
